import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tooltip", {
			dark: _ctx.color === 'dark',
			top: _ctx.direction === 'top',
			bottom: _ctx.direction === 'bottom',
			right: _ctx.direction === 'right',
			left: _ctx.direction === 'left',
		}]),
    style: _normalizeStyle({ width: `${_ctx.width}rem` }),
    ref: "tooltip"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}